export default {
  "hash": "55eb4ca",
  "raw": "v3.27.0",
  "semverString": "3.27.0"
};